



export function Enumerate(
  values,
) {
  return Object.freeze(
    values.reduce(
      (acc, val) => ({
        ...acc,
        [val]: val,
      }),
      {},
    ) ,
  );
}



